const ABSOLUTE_URL_PATTERN = /^(https?:)?\/\//i;

export const getFileUrl = (path: string | null | undefined) => {
  if (!path) return null;

  const trimmed = path.trim();
  if (!trimmed) return null;

  if (ABSOLUTE_URL_PATTERN.test(trimmed) || trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const bucketUrl = process.env.NEXT_PUBLIC_IMAGE_BUCKET_URL?.replace(/\/$/, '') ?? '';
  const relativePath = trimmed.replace(/^\//, '');

  return bucketUrl ? `${bucketUrl}/${relativePath}` : relativePath;
};
